import { gsap } from "gsap";
import Alpine from "alpinejs";
const { wp } = window as any;

Alpine.data("postfilter", () => ({
  posts: [],
  allPosts: {} as any,
  category: '',
  tag: '',

  init() {
    gsap.from(this.$refs.postsContainer, {
      y: 100,
      duration: 1
    })

    wp.api.loadPromise.done(() => {
      this.allPosts = new wp.api.collections.Posts();

      this.fetchPosts();
    });
  },

  fetchPosts() {
    const additionalParams: any = {}
    this.category && (additionalParams.categories = this.category);
    this.tag && (additionalParams.tags = this.tag);

    (this.allPosts as any)
      .fetch({
        data: {
          filter: { orderby: "title", order: "ASC" },
          per_page: 8,
          _embed: true,
          ...additionalParams
        },
      })
      .done(this.updatePosts.bind(this));
  },

  updatePosts(posts) {
    // console.log(posts);
    this.posts = this.transformPosts(posts);
  },

  transformPosts(posts) {
    return posts.map((post) => {
      const featuredMedia = post._embedded["wp:featuredmedia"]?.[0];
      const thumbnailUrl =
        featuredMedia?.media_details?.sizes?.full?.source_url ?? "";

      return {
        title: this.decodeHtml(post.title.rendered), // pass this to x-text NOT x-html
        thumbnail: thumbnailUrl,
        link: post.link
      };
    });
  },

  loadMorePosts() {
    if ((this.allPosts as any).hasMore()) {
      (this.allPosts as any).more().done((posts) => {
        this.addPosts(posts);
      });
    }
  },

  addPosts(posts) {
    this.transformPosts(posts).forEach(post => {
      this.posts.push(post);
    })
  },

  decodeHtml(html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

}));
